import { ArrowDropDown } from '@mui/icons-material';
import { Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useStyles } from '../style';

/**
 * @name NavTitle
 * @description Displays title of nav links
 * @param {object} root0  - destructured object
 * @param {object} root0.nav - Data from Strapi
 * @param {Function} root0.handleClick - OnClick function for expanding nav list
 * @param {Function} root0.handleClose - handleClose function for closing nav list
 * @returns {JSX.Element} ReactJs Element
 */
const NavTitle = ({ nav, handleClick, handleClose }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Link
      href=''
      underline='hover'
      component='a'
      sx={styles.mainNavStyle.mainNavs}
      id={nav?.title}
      aria-label={nav?.Link?.ariaLabel}
      onClick={e => handleClick(e, nav)}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick(e, nav);
        }

        if (e.key === 'Tab') {
          if (e.shiftKey) {
            handleClose();
          }
        }
      }}
    >
      <Typography sx={styles.navTitle}>{nav?.title}</Typography>
      <ArrowDropDown className='dropdownIcon' />
    </Link>
  );
};

NavTitle.displayName = 'NavTitle';
export default NavTitle;
